import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { ControlService } from 'app/main/services/control.service';
import { RiesgoService } from 'app/main/services/riesgo.service';
import { KriService } from 'app/main/services/kri.service';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import { Control } from 'app/main/models/control.model';
import { Riesgo } from 'app/main/models/riesgo.model';
import { EstructuraJerarquica } from 'app/main/models/estructura-jerarquica.model';
import { Kri } from 'app/main/models/kri.model';
import {TranslateService} from '@ngx-translate/core';
import { TokenStorageService } from 'app/main/auth/token-storage.service';

@Component({
  selector: 'add-kri-dialog-box',
  templateUrl: './add-kri-dialog-box.component.html',
  styleUrls: ['./add-kri-dialog-box.component.scss']
})
export class AddKriDialogBoxComponent {

  action: string;
  data: Kri =null;//= new Kri({});
  dataI:any = null;
  hoy:Date = new Date();

  estructura: EstructuraJerarquica = null;
  riesgos: Riesgo[] = [];

  frecuencias= ['DIARIO','SEMANAL','QUINCENAL','MENSUAL','TRIMESTRAL','SEMESTRAL','ANUAL'];



  constructor(
    public dialog: MatDialog,
    public riesgosService : RiesgoService,
    public service : KriService,
    public translate: TranslateService,
    private storage: TokenStorageService,

    public serviceEstructuraJerarquica: EstructuraJerarquicaService,
    public dialogRef: MatDialogRef<AddKriDialogBoxComponent>,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public dataIn: any) {

      var user = this.storage.getUser();

      var today = new Date();
      this.dataI = dataIn;
      this.action = dataIn.action;
      this.estructura = dataIn.estructura;
      this.riesgos = dataIn.riesgos;
      this.data = dataIn;
      if((this.action=='Update' || this.action=='Delete' || this.action=='View') && dataIn.obj!=null){
        this.data = dataIn.obj;
      }
      if(this.action=='Carga' || this.action=='View' ){
        if(this.data.id!=null)
        this.service.get(this.data.id).pipe().subscribe(req => {
          this.data = req.body;
          this.loadData();
        });
      }else{
        this.loadData();
      }
    }

  loadData():void{

    var user = this.storage.getUser();
    var today = new Date();

    if(this.data.fechaInicio!=null)
      this.data.fechaInicio = new Date(this.data.fechaInicio);

    if(this.data.fechaFin!=null)
        this.data.fechaFin = new Date(this.data.fechaFin);

    if(this.data.nodo==null && this.dataI!=null){
      this.data.estructura = this.dataI.estructura;
      this.data.nodo = this.dataI.nodo;
    }

    if(this.data.evaluacion==null && this.dataI!=null && this.dataI.evaluacion!=null){
      this.data.evaluacion = this.dataI.evaluacion;
    }

    var isResponsable = this.data.responsable!=null && this.data.responsable.correoElectronico.trim() == user.trim();
    //&& (this.data.evaluacion.estado=='PRE_INICIADO' || this.data.evaluacion.estado=='INICIADO')
    this.data.tieneEditar = (this.data.evaluacion!=null && isResponsable &&
    (new Date(this.data.fechaInicio)<=today) && (new Date(this.data.fechaFin) >=today)) ? true:false;

    if(this.data!=null && this.data.mediciones!=null)
      this.data.mediciones.sort((a, b) => ((new Date(a.fecha)) > (new Date(b.fecha))) ? 1 : -1);
  }

  doAction(): void{
    if(this.action=='Update'){
      this.service.edit(this.data.id,this.data).pipe().subscribe(req => {
        this.dialogRef.close({event: this.action, data: req.body});
      });
    }else{
      this.dialogRef.close({event: this.action, data: this.data});
    }
  }

  closeDialog(): void{
   /* if(this.action=='Update'){
      this.service.edit(this.data.id,this.data).pipe().subscribe(req => {
        this.dialogRef.close({event: this.action, data: req.body});
      });
    }else{*/
      this.dialogRef.close({event: 'Cancel', data: this.data});
    //}
  }


  openDialog(): void {
    const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
      width: '100%',
      data: {estructura:this.estructura,action:'ADD'},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.data.nodo = result.data.nodo;
      this.data.estructura = result.data.estructura;

    });
  }

  compareObjects(o1: any, o2: any): boolean {
    var equals = false;
    if(o1!=null && o2!=null && typeof o1 === 'object' &&  typeof o2 === 'object' && 'id' in o1 && 'id' in o2 && o1.id === o2.id){
      equals = true;
    }else{
      equals = (o1 == o2)? true:false;
    }

    return equals;
  }

  compareResponsable(o1: any, o2: any): boolean {
    var equals = false;
    if(o1!=null && o2!=null && typeof o1 === 'object' &&  typeof o2 === 'object' && 'id' in o1 && 'id' in o2 && o1.id === o2.id){
      equals = true;
    }else{
      equals = (o1 == o2)? true:false;
    }

    return equals;
  }

  ngOnInit(): void {

  }

}
